import requests from "./httpService";

const PhyicalYearService = {
  getPhysicalYear(id, body) {
    return requests.get(`/settings/all?company_id=${id}`, body);
  },
  getPhysicalYearDetails(id, body) {
    return requests.get(`/settings/details/${id}`, body);
  },
  createPhysicalYear(body) {
    return requests.post(`/settings/create`, body);
  },
 updatePhysicalYear(id,sat,body) {
    return requests.post(`settings/update/${id}?status=${sat}`, body);
  },
};

export default PhyicalYearService;
